import { twMerge } from '@florencelabs/fabric-styles';
import clsx from 'clsx';
import { ReactElement } from 'react';
import './split-screen.component.css';

interface AdditionalClassname {
  screen?: string;
  children?: string;
}
interface AdditionalClassnames {
  main: string;
  left: AdditionalClassname;
  right: AdditionalClassname;
}
interface SplitScreenProps {
  children: [ReactElement, ReactElement];
  isOriginalOrder?: boolean;
  additionalClassnames?: Partial<AdditionalClassnames>;
}

export const SplitScreen = ({
  children,
  isOriginalOrder,
  additionalClassnames,
}: SplitScreenProps): ReactElement => {
  const [left, right] = children;

  return (
    <div
      className={clsx(
        'split-screen flex flex-1 flex-col desktop:flex-row',
        additionalClassnames?.main,
      )}
    >
      <div
        className={clsx(
          'split-screen-left order-2 flex w-full flex-col items-start gap-8 desktop:w-1/2',
          'desktop:order-1 desktop:items-end',
          'desktop:relative desktop:bottom-0 desktop:top-0',
          isOriginalOrder && 'order-1 desktop:order-1',
          additionalClassnames?.left?.screen,
        )}
      >
        <div
          className={clsx(
            'flex h-full flex-col',
            'w-full px-6 tablet:px-16 desktop:max-w-[40rem] desktop:px-12 desktop:pr-[108px]',
            additionalClassnames?.left?.children,
          )}
        >
          {left}
        </div>
      </div>
      <div
        className={clsx(
          'split-screen-right order-1 w-full items-start gap-8 pb-0 pt-6 desktop:w-1/2',
          'desktop:order-2 desktop:flex-1 desktop:pt-10',
          'desktop:relative desktop:bottom-0 desktop:right-0 desktop:top-0',
          isOriginalOrder && 'order-2 desktop:order-2',
          additionalClassnames?.right?.screen,
        )}
      >
        <div
          className={twMerge(
            'w-full px-6 tablet:px-16 desktop:max-w-[40rem] desktop:px-0',
            additionalClassnames?.right?.children,
          )}
        >
          {right}
        </div>
      </div>
    </div>
  );
};
